module.exports = __webpack_public_path__ + "images/digital-forum.de1830ed.webp";